import { render, staticRenderFns } from "./SimpleClose.vue?vue&type=template&id=3baa63d7&scoped=true&"
import script from "./SimpleClose.vue?vue&type=script&lang=js&"
export * from "./SimpleClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baa63d7",
  null
  
)

export default component.exports